import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Tooltip from "./components/Tooltip";
import ParameterInput from "./components/ParameterInput";
import Stack from "react-bootstrap/Stack";
function Input() {
  return (
    <div className="input-container">
      <Stack gap={3} style={{ alignItems: "center" }}>
        <Tooltip>
          {
            <div>
              <span className="material-symbols-rounded">smart_toy</span>
              AI-Powered Toxicology
            </div>
          }
        </Tooltip>
        <h1 style={{ textAlign: "center" }} className="dt-header-dark">
          ToxDT: Toxicological Digital Twin
        </h1>
        <div style={{ maxWidth: "600px" }} className="description-text">
          Predict chemical toxicity, estimate benchmark doses, and optimize
          experimental design using our advanced rodent digital twin, powered by
          AI.
        </div>
        <ParameterInput />
        <Stack
          direction="horizontal"
          style={{
            justifyContent: "center",
            alignSelf: "center",
            maxWidth: "1400px",
            marginTop: "5vh",
          }}
          gap={5}
        >
          <div className="floating-modal gray">
            <span
              className="material-symbols-rounded  description-modal-icon"
              style={{
                fontVariationSettings: "'FILL' 1",
              }}
            >
              leaderboard
            </span>
            <h5 className="description-modal-header" style={{ fontWeight: "bold" }}>Endpoint Sensitivity</h5>
            <div className="description-text" style={{textAlign: 'center'}}>
              Analyze 242 endpoints across various organs to identify target
              organs and rank endpoint sensitivity.
            </div>
          </div>
          <div className="floating-modal gray">
            <span className="material-symbols-rounded description-modal-icon">
              genetics
            </span>
            <h5 className="description-modal-header" style={{ fontWeight: "bold" }}>Toxicity Assessment</h5>
            <div className="description-text" style={{textAlign: 'center'}}>
              Estimate Benchmark Doses (BMDs) with probabilistic confidence
              intervals for responsive endpoints.
            </div>
          </div>
          <div className="floating-modal gray">
            <span
              className="material-symbols-rounded description-modal-icon"
              style={{
                fontVariationSettings: "'FILL' 1",
              }}
            >
              biotech
            </span>
            <h5 className="description-modal-header" style={{ fontWeight: "bold" }}>Design Optimization</h5>
            <div className="description-text" style={{textAlign: 'center'}}>
              Get AI-optimized study designs, dose ranges, and animal counts for
              acute, subchronic, and chronic studies.
            </div>
          </div>
        </Stack>
      </Stack>
    </div>
  );
}
export default Input;
